import { SpiceCarousel } from "./SpiceCarousel";
import { Actions } from "./Actions";
import { useCache } from "@/hooks/useCache";
import { useSpices } from "@/hooks/useSpices";

interface ToolbarProps {
  selectedSpice: number | null;
  onSelectSpice: (id: number | null) => void;
  onOpenList: () => void;
  isListOpen: boolean;
  spiceCount: number;
  onShowInfo?: () => void;
  showInfo?: boolean;
  className?: string;
}

export function Toolbar({
  selectedSpice,
  onSelectSpice,
  onOpenList,
  isListOpen,
  spiceCount,
  onShowInfo,
  showInfo = false,
  className = "",
}: ToolbarProps) {
  const { data } = useCache();
  const { removeSpice } = useSpices();
  const selectedSpiceData = selectedSpice && data && data[selectedSpice];

  const handleRemove = () => {
    if (selectedSpice) {
      removeSpice(selectedSpice);
      onSelectSpice(null);
    }
  };

  return (
    <div className={className}>
      {/* Desktop: Spice header with remove button */}
      {selectedSpiceData && (
        <div className="hidden lg:flex justify-between items-center pb-3 border-b border-secondary/10">
          <span className="font-semibold text-secondary text-base">{selectedSpiceData.name}</span>
          <button
            type="button"
            onClick={handleRemove}
            className="text-sm text-secondary opacity-50 hover:opacity-100 hover:underline transition-opacity"
          >
            Remove
          </button>
        </div>
      )}

      {/* Mobile: Carousel and actions */}
      <div className="lg:hidden flex flex-col gap-2 pb-2">
        <div className="flex items-center gap-2">
          <SpiceCarousel selectedSpice={selectedSpice} onSelect={onSelectSpice} />
          <Actions
            onOpenList={onOpenList}
            isListOpen={isListOpen}
            onInfo={onShowInfo}
            isInfoOpen={showInfo}
          />
        </div>
      </div>
    </div>
  );
}
